import { createSlice, createAsyncThunk } from '@reduxjs/toolkit'
import { getImageAlert } from '../action/minioAction'
// import { deleteCluster, findCluster, getClusterList, postCluster } from "../action/clusterAction";
// import axios from "axios";
// import cartItems from "../api";

const initialState = {
  message: '',
  type: '',
  alertData: [],
  imageData: '',
  isOpenMessage: false,
  isLoading: false,
}
const messageSlice = createSlice({
  name: 'message',
  initialState,
  reducers: {
    openMessage: (state, action) => { 
      state.isOpenMessage = action.payload.open
      state.message = action.payload.message
      state.type = action.payload.type
    },
    openAlert: (state, action) => {
      if(action.payload.data !== ''){
        let data = JSON.parse(action.payload.data)
        state.alertData = data.data
      }else{
        state.alertData = []
      }
    },
  },
  extraReducers: {
    [getImageAlert.pending]: (state) => {
      state.isLoading = true;
    },
    [getImageAlert.fulfilled]: (state, action) => {
      state.imageData = action.payload;
      state.isLoading = false;
    },
    [getImageAlert.rejected]: (state) => {
      state.isLoading = false;
    },
  },
})

export const { openMessage, openAlert } = messageSlice.actions
export default messageSlice.reducer
